import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDashboard } from "../../redux/actions/dashboard.actions";
import PieChartCard from "../../components/comman/charts/piecharts";
import ShimmerCard from "./DashboardShimmer";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import {
	Campaign,
	LibraryBooks,
	ListAlt,
	Person,
	Work,
} from "@mui/icons-material";
import "./dashboard.scss";

const Dashboard = () => {
	const dispatch = useDispatch();
	const { dashboard, loading } = useSelector((state) => state.dashboardReducer);

	useEffect(() => {
		dispatch(getDashboard());
	}, [dispatch]);

	const total = [
		{ label: "USERS", total: dashboard?.users?.total || 0, icon: Person },
		{ label: "BRANDS", total: dashboard?.brands?.total || 0, icon: Work },
		{ label: "OFFERINGS", total: dashboard?.offerings?.total || 0, icon: ListAlt },
		{ label: "COLLECTIONS", total: dashboard?.collections?.total || 0, icon: LibraryBooks },
		{ label: "CAMPAIGNS", total: dashboard?.campaigns?.total || 0, icon: Campaign },
	];

	const Active = [
		{ label: "USERS", active: dashboard?.users?.active || 0, icon: Person },
		{ label: "BRANDS", active: dashboard?.brands?.active || 0, icon: Work },
		{ label: "OFFERINGS", active: dashboard?.offerings?.active || 0, icon: ListAlt },
		{ label: "COLLECTIONS", active: dashboard?.collections?.active || 0, icon: LibraryBooks },
		{ label: "CAMPAIGNS", active: dashboard?.campaigns?.active || 0, icon: Campaign },
	];

	const totalData = total.map(item => ({ label: item.label, value: item.total }));
	const activeData = Active.map(item => ({ label: item.label, value: item.active }));
	const dashboardCards = total.map((item, index) => ({
		label: item.label,
		total: item.total,
		active: Active[index]?.active || 0,
		icon: item.icon,
	}));

	const listVariants = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: {
				staggerChildren: 0.08,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
	};

	return (
		<div className="dashboard-page">
			<motion.div
				className="dashboard-intro"
				initial={{ opacity: 0, y: -16 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.45, ease: "easeOut" }}
			>
				<h2 className="dashboard-title">Dashboard Overview</h2>
				<p className="dashboard-subtitle">Monitor totals and active records across the platform.</p>
			</motion.div>

			<motion.div
				className="dashboard-metrics-grid"
				variants={listVariants}
				initial="hidden"
				animate="show"
			>
				{dashboardCards.map((item) => {
					const Icon = item.icon;
					return (
						<motion.div
							key={item.label}
							className="metric-card"
							variants={itemVariants}
							whileHover={{ y: -4, scale: 1.02 }}
							whileTap={{ scale: 0.99 }}
						>
							<div className="metric-head">
								<motion.div
									className="metric-icon-wrap"
									animate={{ rotate: [0, 6, -6, 0] }}
									transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
								>
									<Icon className="metric-icon" />
								</motion.div>
								<span className="metric-label">{item.label}</span>
							</div>
							<div className="metric-values">
								<p>
									<span>Total</span>
									<CountUp end={item.total} duration={1.1} separator="," />
								</p>
								<p>
									<span>Active</span>
									<CountUp end={item.active} duration={1.1} separator="," />
								</p>
							</div>
						</motion.div>
					);
				})}
			</motion.div>

			<motion.div
				className="dashboard-chart-grid"
				variants={listVariants}
				initial="hidden"
				animate="show"
			>
				{loading ? (
					<>
						<motion.div variants={itemVariants}>
							<ShimmerCard />
						</motion.div>
						<motion.div variants={itemVariants}>
							<ShimmerCard />
						</motion.div>
					</>
				) : (
					<>
						<motion.div variants={itemVariants} whileHover={{ y: -4 }}>
							<PieChartCard title="Total Overview" data={totalData} />
						</motion.div>
						<motion.div variants={itemVariants} whileHover={{ y: -4 }}>
							<PieChartCard title="Active Overview" data={activeData} />
						</motion.div>
					</>
				)}
			</motion.div>
		</div>
	);
};

export default Dashboard;
